import { render } from "./SpaceMain.vue?vue&type=template&id=10fd466a&scoped=true"
import script from "./SpaceMain.vue?vue&type=script&lang=js"
export * from "./SpaceMain.vue?vue&type=script&lang=js"

import "./SpaceMain.vue?vue&type=style&index=0&id=10fd466a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fd466a"]])

export default __exports__